"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ObjectId = require('bson').ObjectID;

var clone = require('clone');

var tv4 = require('tv4');

var _require = require('../../helper/card-factory'),
    createCardFactory = _require.createCardFactory;

var TemplateSection = /*#__PURE__*/function () {
  function TemplateSection(opt) {
    _classCallCheck(this, TemplateSection);

    this.id = null;
    this.header = '';
    this.allowableCards = [];
    this.cardDefinitions = [];
    this.isMovable = true;

    if (opt) {
      this.fillObject(clone(opt));
    }
  }

  _createClass(TemplateSection, [{
    key: "fillObject",
    value: function fillObject(opt) {
      var _this = this;

      this.id = new ObjectId(opt.id);
      this.header = opt.header || '';
      this.allowableCards = opt.allowableCards || [];
      this.isMovable = !!opt.isMovable;

      if (opt.cardDefinitions) {
        opt.cardDefinitions.forEach(function (card) {
          _this.cardDefinitions.push(createCardFactory(card.type, card));
        });
      }
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, TemplateSection.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'template-section.schema.json',
        type: 'object',
        additionalProperties: false,
        properties: {
          id: {
            type: ['object', 'null']
          },
          header: {
            type: 'string'
          },
          isMovable: {
            type: 'boolean'
          },
          allowableCards: {
            type: 'array',
            item: {
              type: 'object'
            }
          },
          cardDefinitions: {
            type: 'array',
            items: {
              type: 'object'
            }
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return TemplateSection;
}();

module.exports = TemplateSection;